"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideNavUserAvatar = SideNavUserAvatar;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
function SideNavUserAvatar(props) {
    var photoUrl = props.photoUrl, initials = props.initials, fullName = props.fullName;
    // Track the failing URL rather than a boolean so a later photo update isn't suppressed by an earlier failure.
    var _a = (0, react_1.useState)(null), failedPhotoUrl = _a[0], setFailedPhotoUrl = _a[1];
    var photo = photoUrl && photoUrl !== failedPhotoUrl ? photoUrl : null;
    if (photo) {
        return ((0, jsx_runtime_1.jsx)("img", { src: photo, alt: fullName ? "".concat(fullName, " profile") : "Profile", title: fullName || undefined, onError: function () { return setFailedPhotoUrl(photo); }, className: "size-10 rounded-full object-cover bg-white/10 shrink-0" }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { title: fullName || undefined, className: "flex items-center justify-center size-10 rounded-full bg-white/10 text-white text-sm font-semibold shrink-0", children: initials || "?" }));
}
